module.exports = __webpack_public_path__ + "static/media/icon-profile-completing.aef115ed.svg";